module.exports = __webpack_public_path__ + "img/linkedin.831a9224.svg";